import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { strings } from 'APP_ROOT/localization';
import geofences from 'APP_ROOT/data/geofences';

class Address extends React.Component {

    static propTypes = {
        address: PropTypes.string
    }

    render () {

        return (
            <section>
                <h4 className="label">{strings.resource_address}</h4>
                <div className="value">{this.props.address}</div>
            </section>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        address: geofences.Selectors.geofenceAddress(state, ownProps.geofenceId)
    };
};

export default connect(mapStateToProps)(Address);
